/**
 * LoadingScreen.tsx
 *
 * Simple loading screen component for displaying a loading state.
 */
// src/components/LoadingScreen.tsx
import React from "react";
import "../styles/component/LoadingScreen.css"

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = "Loading your messages..." }) => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-spinner"></div>
        <div className="loading-text">{message}</div>
      </div>
    </div>
  );
};

export default React.memo(LoadingScreen);
